function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import Tick from "./Tick";
import Indeterminate from "./Indeterminate";
import "./ChedioButtox.css";
export default function ChedioButtox(_ref) {
  let {
    children,
    className,
    disabled,
    inputType,
    invalid,
    title,
    onClick,
    indeterminate,
    checked,
    ...rest
  } = _ref;

  const getMarker = () => {
    if (indeterminate) {
      return /*#__PURE__*/React.createElement(Indeterminate, null);
    }

    if (checked) {
      return /*#__PURE__*/React.createElement(Tick, null);
    }
  };

  const getAriaChecked = () => {
    if (indeterminate) {
      return "mixed";
    }

    if (checked) {
      return true;
    }

    return false;
  };

  const handleClick = onClick && (e => {
    if (e.target.tagName !== "INPUT") {
      e.stopPropagation();
      return;
    }

    onClick(e);
  });

  const classes = classnames(className, {
    [`${className}--disabled`]: disabled,
    [`${className}--invalid`]: invalid,
    [`${className}--indeterminate`]: indeterminate
  });
  return /*#__PURE__*/React.createElement(Base, {
    Component: "label",
    className: classes,
    onClick: handleClick,
    space: "x2",
    title: title
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    checked: checked,
    className: `${className}__input`,
    disabled: disabled,
    type: inputType,
    "aria-checked": getAriaChecked()
  })), /*#__PURE__*/React.createElement("span", {
    className: `${className}__indicator`
  }, inputType === "checkbox" && getMarker()), children && /*#__PURE__*/React.createElement("span", {
    className: `${className}__label`
  }, children));
}